module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('choose-store-modal', {
    attrs: {
      "option": _vm.storeOption,
      "tooltip": "此操作將會覆蓋該門市原有的設定內容"
    },
    on: {
      "copyStore": _vm.copyStore
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delExceptionOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box text-center"
  }, [(_vm.storeInfo.brand_name) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-74px",
      "left": "165px",
      "font-size": "18px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.storeInfo.brand_name) + " - " + _vm._s(_vm.storeInfo.name_short) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      'active': _vm.storeMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("基本資訊")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("細部設定")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(3)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("預訂/訂購時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(4)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("付款方式")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 5
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(5)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("製作/取餐時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 6
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(6)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("取餐方式/門檻")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 7
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(7)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("營業/公休時間")])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 8
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(8)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("塑膠袋")])]) : _vm._e(), _vm._v(" "), (_vm.info && _vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(10)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("出單機")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'crStore') ? _c('li', {
    class: {
      'active': _vm.storeMethod == 11
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(11)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("網址設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 && _vm.hasCommissionPermission) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 12
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(12)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("計費方式設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 13
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 13
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("物流設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 14
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(14)
      }
    }
  }, [_c('a', {
    class: {
      'cursor-none': _vm.$route.name === 'crStore'
    }
  }, [_vm._v("服務費設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 15
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 15
      }
    }
  }, [_c('a', [_vm._v("特殊需求")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 1),
      expression: "storeMethod === 1"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.name),
      expression: "storeInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.name_short),
      expression: "storeInfo.name_short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.name_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "name_short", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.$route.name !== 'upStore') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupSelect),
      expression: "groupSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.groupSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.groupList), function(group, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              城市\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.citySelect),
      expression: "citySelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.citySelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cityOption), function(city, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": city.value
      }
    }, [_vm._v("\n                  " + _vm._s(city.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              區域\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaSelect),
      expression: "areaSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.areaSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.areaOption), function(area, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": area.value
      }
    }, [_vm._v("\n                  " + _vm._s(area.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              地址\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.address_short),
      expression: "storeInfo.address_short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "120"
    },
    domProps: {
      "value": (_vm.storeInfo.address_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "address_short", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              地址備註\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.address_remark),
      expression: "storeInfo.address_remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.storeInfo.address_remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "address_remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.tel),
      expression: "storeInfo.tel"
    }],
    ref: "tel",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.storeInfo.tel)
    },
    on: {
      "keyup": _vm.verityTel,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "tel", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              電話2\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.tel2),
      expression: "storeInfo.tel2"
    }],
    ref: "tel2",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.storeInfo.tel2)
    },
    on: {
      "keyup": _vm.verityTel2,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "tel2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              電子信箱\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.email),
      expression: "storeInfo.email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.storeInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.description),
      expression: "storeInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述(搜尋引擎顯示)\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.search_description),
      expression: "storeInfo.search_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.search_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "search_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              品牌頁介紹\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.introduction),
      expression: "storeInfo.introduction"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "introduction",
      "cols": "30",
      "rows": "10",
      "maxlength": "65535"
    },
    domProps: {
      "value": (_vm.storeInfo.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "introduction", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              Youtube影片代碼\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.youtube_video_code),
      expression: "storeInfo.youtube_video_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.storeInfo.youtube_video_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "youtube_video_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              店家公告\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.comment),
      expression: "storeInfo.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              統一編號\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.ein),
      expression: "storeInfo.ein"
    }],
    ref: "ein",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.storeInfo.ein)
    },
    on: {
      "keyup": _vm.verityEin,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "ein", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              抬頭\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.bl_name),
      expression: "storeInfo.bl_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.storeInfo.bl_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "bl_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              食品業者登錄字號\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.food_business_no),
      expression: "storeInfo.food_business_no"
    }],
    ref: "foodBusinessNo",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "19",
      "placeholder": "範例：F-123456789-00000-0"
    },
    domProps: {
      "value": (_vm.storeInfo.food_business_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "food_business_no", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              肉品產地說明\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.meat_origin_description),
      expression: "storeInfo.meat_origin_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "maxlength": "500",
      "placeholder": "範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
    },
    domProps: {
      "value": (_vm.storeInfo.meat_origin_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "meat_origin_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              LOGO\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.image_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [(_vm.imgLogoOption.length) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgLogoSelect),
      expression: "imgLogoSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.imgLogoSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.imgLogoOption), function(img, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": img.name
      }
    }, [_vm._v("\n                    " + _vm._s(img.name) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    class: {
      'm-t-25': !_vm.imgLogoOption.length
    },
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              底圖照片\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.photo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.photo_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.photo_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-photo-load"
    }
  }, [_vm._v("\n                選擇圖片\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-photo-load"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              餐點種類\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "餐點種類",
      "placeholder": "餐點種類",
      "label": "label",
      "track-by": "value",
      "options": _vm.mealTagList,
      "multiple": true
    },
    model: {
      value: (_vm.storeInfo.binding_meal_tag_ids),
      callback: function($$v) {
        _vm.$set(_vm.storeInfo, "binding_meal_tag_ids", $$v)
      },
      expression: "storeInfo.binding_meal_tag_ids"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              品牌下店家代碼\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.branch_code),
      expression: "storeInfo.branch_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.branch_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "branch_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              POS店家代碼\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.pos_branch_code),
      expression: "storeInfo.pos_branch_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.pos_branch_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "pos_branch_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 10 || _vm.getRoleType === 30) ? _c('div', [_vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              店家公告\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.comment),
      expression: "storeInfo.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              城市\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.citySelect),
      expression: "citySelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.citySelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cityOption), function(city, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": city.value
      }
    }, [_vm._v("\n                  " + _vm._s(city.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              區域\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaSelect),
      expression: "areaSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.areaSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.areaOption), function(area, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": area.value
      }
    }, [_vm._v("\n                  " + _vm._s(area.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              地址\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  如有開通米特物流服務，修改地址後請同步通知米特物流窗口。\n                ")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.address_short),
      expression: "storeInfo.address_short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "120"
    },
    domProps: {
      "value": (_vm.storeInfo.address_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "address_short", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              地址備註\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.address_remark),
      expression: "storeInfo.address_remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.storeInfo.address_remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "address_remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.tel),
      expression: "storeInfo.tel"
    }],
    ref: "tel",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.storeInfo.tel)
    },
    on: {
      "keyup": _vm.verityTel,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "tel", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              電話2\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.tel2),
      expression: "storeInfo.tel2"
    }],
    ref: "tel2",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.storeInfo.tel2)
    },
    on: {
      "keyup": _vm.verityTel2,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "tel2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.description),
      expression: "storeInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述(搜尋引擎顯示)\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.search_description),
      expression: "storeInfo.search_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.search_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "search_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              品牌頁介紹\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.introduction),
      expression: "storeInfo.introduction"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "introduction",
      "cols": "30",
      "rows": "10",
      "maxlength": "65535"
    },
    domProps: {
      "value": (_vm.storeInfo.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "introduction", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              Youtube影片代碼\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.youtube_video_code),
      expression: "storeInfo.youtube_video_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.storeInfo.youtube_video_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "youtube_video_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              食品業者登錄字號\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.food_business_no),
      expression: "storeInfo.food_business_no"
    }],
    ref: "foodBusinessNo",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "19",
      "placeholder": "範例：F-123456789-00000-0"
    },
    domProps: {
      "value": (_vm.storeInfo.food_business_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "food_business_no", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              肉品產地說明\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.meat_origin_description),
      expression: "storeInfo.meat_origin_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "maxlength": "500",
      "placeholder": "範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
    },
    domProps: {
      "value": (_vm.storeInfo.meat_origin_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "meat_origin_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              LOGO\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.image_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [(_vm.imgLogoOption.length) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgLogoSelect),
      expression: "imgLogoSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.imgLogoSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.imgLogoOption), function(img, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": img.name
      }
    }, [_vm._v("\n                    " + _vm._s(img.name) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    class: {
      'm-t-25': !_vm.imgLogoOption.length
    },
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              底圖照片\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.photo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.photo_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.photo_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-photo-load"
    }
  }, [_vm._v("\n                選擇圖片\n              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-photo-load"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  })])])]), _vm._v(" "), _vm._m(10)]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 2),
      expression: "storeMethod === 2"
    }],
    staticClass: "box-body form"
  }, [_c('div', [(_vm.getRoleType !== 10) ? _c('div', [_c('h3', [_vm._v("細部設定")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apiTypeSelect),
      expression: "apiTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.apiTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("專屬客製POS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("公版POS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("平板接單")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              門市類型\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  若尚未設定門市類型，將會影響加盟/直營對帳的計費功能\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeTypeSelect),
      expression: "storeTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分類")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("直營")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("加盟")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("尚未營業")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("籌備中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("營業中(上架)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("休息中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("已歇業")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disModeSelect),
      expression: "disModeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disModeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("走路模式(WALKING)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("開車模式(DRIVING)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("機車(SCOOTER)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("大眾運輸(TRANSIT)")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barcodeSelect),
      expression: "barcodeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.barcodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不支援")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("一維條碼")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("二維條碼(QRcode)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("一維、二維都支援")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roundingTypeSelect),
      expression: "roundingTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.roundingTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("無條件進位")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("無條件捨去")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("四捨五入")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("保留小數點")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponFormSelect),
      expression: "couponFormSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.couponFormSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("依付款方式使用優惠券")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("依虛擬商品使用優惠券")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProdSettingSelect),
      expression: "showProdSettingSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.showProdSettingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("別名跟描述不顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("別名跟描述都顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("只顯示別名")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("只顯示描述")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInvoiceException),
      expression: "isInvoiceException"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceException",
      "disabled": !_vm.hasInvoiceSelected
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isInvoiceException, 0)
    },
    on: {
      "change": function($event) {
        _vm.isInvoiceException = 0
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'radio-text--disabled': !_vm.hasInvoiceSelected
    }
  }, [_vm._v("\n                    開發票\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInvoiceException),
      expression: "isInvoiceException"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceException",
      "disabled": _vm.hasInvoiceSelected
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isInvoiceException, 1)
    },
    on: {
      "change": function($event) {
        _vm.isInvoiceException = 1
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'radio-text--disabled': _vm.hasInvoiceSelected
    }
  }, [_vm._v("\n                    免開發票\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoicePaperSelect),
      expression: "hasInvoicePaperSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoicePaperOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoicePaperSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoicePaperSelect = 1
      }
    }
  }), _vm._v("開放\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoicePaperSelect),
      expression: "hasInvoicePaperSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoicePaperOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoicePaperSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoicePaperSelect = 0
      }
    }
  }), _vm._v("停用\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceCarrierSelect),
      expression: "hasInvoiceCarrierSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoiceCarrierSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceCarrierSelect = 1
      }
    }
  }), _vm._v("\n                  開放 (請確認POS端是否支援此功能)\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceCarrierSelect),
      expression: "hasInvoiceCarrierSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoiceCarrierSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceCarrierSelect = 0
      }
    }
  }), _vm._v("\n                  停用\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.hasInvoiceCarrierSelect) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開放愛心捐贈發票\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  門市接單APP暫不支援\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceNpobnaSelect),
      expression: "hasInvoiceNpobnaSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceNpobnaOption",
      "disabled": !_vm.hasInvoiceCarrierSelect
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoiceNpobnaSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceNpobnaSelect = 1
      }
    }
  }), _vm._v("開放\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceNpobnaSelect),
      expression: "hasInvoiceNpobnaSelect"
    }],
    attrs: {
      "type": "radio",
      "disabled": true,
      "name": "invoiceNpobnaOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoiceNpobnaSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceNpobnaSelect = 0
      }
    }
  }), _vm._v("停用\n                ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              發票備註\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceRemark),
      expression: "invoiceRemark"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "invoiceRemark",
      "cols": "30",
      "rows": "3",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.invoiceRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceRemark = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.invoiceRemark ? _vm.invoiceRemark.length : 0) + "/100")]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isVisibleSelect),
      expression: "isVisibleSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "showOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isVisibleSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.isVisibleSelect = "1"
      }
    }
  }), _vm._v("顯示\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isVisibleSelect),
      expression: "isVisibleSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "showOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isVisibleSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.isVisibleSelect = "0"
      }
    }
  }), _vm._v("隱藏\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "searchOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isSearchSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.isSearchSelect = "1"
      }
    }
  }), _vm._v("是\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "searchOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isSearchSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.isSearchSelect = "0"
      }
    }
  }), _vm._v("否\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStickerSelect),
      expression: "isStickerSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "stickerOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isStickerSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.isStickerSelect = 1
      }
    }
  }), _vm._v("支援 (請確認POS端是否支援此功能)\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStickerSelect),
      expression: "isStickerSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "stickerOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isStickerSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.isStickerSelect = 0
      }
    }
  }), _vm._v("不支援\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy.trim",
      value: (_vm.storeInfo.custom_sticker_max_length),
      expression: "storeInfo.custom_sticker_max_length",
      modifiers: {
        "number": true,
        "lazy": true,
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "僅可輸入數字",
      "type": "number",
      "min": "1",
      "max": "10"
    },
    domProps: {
      "value": (_vm.storeInfo.custom_sticker_max_length)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.storeInfo, "custom_sticker_max_length", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("強制阻擋外送門檻")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                若選擇強制阻擋外送門檻，消費者訂購時必須符合「取餐方式/門檻-消費金額與距離門檻」的設定才可下單。注意 : 無論是否強制阻擋外送門檻，外送訂單均須符合最低金額門檻才可下單。\n              ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.delivery_stage_limit_type),
      expression: "storeInfo.delivery_stage_limit_type"
    }],
    attrs: {
      "type": "radio",
      "name": "deliveryStageLimit"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.delivery_stage_limit_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "delivery_stage_limit_type", 1)
      }
    }
  }), _vm._v("不強制\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.delivery_stage_limit_type),
      expression: "storeInfo.delivery_stage_limit_type"
    }],
    attrs: {
      "type": "radio",
      "name": "deliveryStageLimit"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.delivery_stage_limit_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "delivery_stage_limit_type", 2)
      }
    }
  }), _vm._v("強制\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_support_custom_remark),
      expression: "storeInfo.is_support_custom_remark"
    }],
    attrs: {
      "type": "radio",
      "name": "customRemark"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_support_custom_remark, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_support_custom_remark", 1)
      }
    }
  }), _vm._v("開啟 (請確認POS端是否支援此功能)\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_support_custom_remark),
      expression: "storeInfo.is_support_custom_remark"
    }],
    attrs: {
      "type": "radio",
      "name": "customRemark"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_support_custom_remark, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_support_custom_remark", 0)
      }
    }
  }), _vm._v("停用\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            網址跳轉設定\n          ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.urlRedirection.stores,
      "tag-placeholder": "選擇網址跳轉門市",
      "placeholder": "選擇網址跳轉門市",
      "label": "name",
      "track-by": "store_id",
      "max": 1,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.urlRedirection.new_store_info),
      callback: function($$v) {
        _vm.$set(_vm.urlRedirection, "new_store_info", $$v)
      },
      expression: "urlRedirection.new_store_info"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 && _vm.membershipGroupType === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.membership_provider_parent_id),
      expression: "storeInfo.membership_provider_parent_id"
    }],
    attrs: {
      "type": "radio",
      "name": "providerId"
    },
    domProps: {
      "value": _vm.providerId,
      "checked": _vm._q(_vm.storeInfo.membership_provider_parent_id, _vm.providerId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "membership_provider_parent_id", _vm.providerId)
      }
    }
  }), _vm._v("是\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.membership_provider_parent_id),
      expression: "storeInfo.membership_provider_parent_id"
    }],
    attrs: {
      "type": "radio",
      "name": "providerId"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.membership_provider_parent_id, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "membership_provider_parent_id", 0)
      }
    }
  }), _vm._v("否\n                ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('h3', [_vm._v("門市下訂金額限制")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.one_order_max_money),
      expression: "storeInfo.one_order_max_money"
    }],
    ref: "oneOrderMaxMoney",
    staticClass: "form-control",
    attrs: {
      "placeholder": "單筆訂單最高上限",
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.storeInfo.one_order_max_money)
    },
    on: {
      "keyup": _vm.verityOneOrderMaxMoney,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "one_order_max_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('h3', [_vm._v("菜單設定")]), _vm._v(" "), (_vm.getRoleType === 30) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "text-left mb-3"
  }, [_vm._v("菜單呈現")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_layout_type),
      expression: "storeInfo.menu_layout_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.storeInfo, "menu_layout_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.menuLayout), function(layout) {
    return _c('option', {
      key: layout.value,
      domProps: {
        "value": layout.value
      }
    }, [_vm._v("\n                    " + _vm._s(layout.label) + "\n                  ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "0"
      }
    }
  }), _vm._v("全部顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "1"
      }
    }
  }), _vm._v("無溫度顯示冷\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "2")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "2"
      }
    }
  }), _vm._v("皆顯示無溫度\n                    ")])])])])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_product_icon),
      expression: "storeInfo.show_menu_product_icon"
    }],
    attrs: {
      "type": "radio",
      "name": "prodIconOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.show_menu_product_icon, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_product_icon", 1)
      }
    }
  }), _vm._v("顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_product_icon),
      expression: "storeInfo.show_menu_product_icon"
    }],
    attrs: {
      "type": "radio",
      "name": "prodIconOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.show_menu_product_icon, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_product_icon", 0)
      }
    }
  }), _vm._v("隱藏\n                    ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_expand_type),
      expression: "storeInfo.menu_expand_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuExpandType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_expand_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_expand_type", 1)
      }
    }
  }), _vm._v("隱藏\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_expand_type),
      expression: "storeInfo.menu_expand_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuExpandType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_expand_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_expand_type", 2)
      }
    }
  }), _vm._v("展開\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_today_type),
      expression: "storeInfo.menu_stop_sale_today_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleTodayType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_today_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_today_type", 1)
      }
    }
  }), _vm._v("顯示當日停賣ICON\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_today_type),
      expression: "storeInfo.menu_stop_sale_today_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleTodayType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_today_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_today_type", 2)
      }
    }
  }), _vm._v("隱藏當日停賣商品\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_type),
      expression: "storeInfo.menu_stop_sale_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_type", 1)
      }
    }
  }), _vm._v("顯示永久停賣ICON\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_type),
      expression: "storeInfo.menu_stop_sale_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_type", 2)
      }
    }
  }), _vm._v("隱藏永久停賣商品\n                    ")])])])])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_zero_money),
      expression: "storeInfo.show_menu_zero_money"
    }],
    attrs: {
      "type": "radio",
      "name": "show_menu_zero_money"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.show_menu_zero_money, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_zero_money", 1)
      }
    }
  }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_zero_money),
      expression: "storeInfo.show_menu_zero_money"
    }],
    attrs: {
      "type": "radio",
      "name": "show_menu_zero_money"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.show_menu_zero_money, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_zero_money", 0)
      }
    }
  }), _vm._v("\n                      關閉\n                    ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.allow_update_menu),
      expression: "storeInfo.allow_update_menu"
    }],
    attrs: {
      "type": "radio",
      "name": "allow_update_menu"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.allow_update_menu, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "allow_update_menu", 1)
      }
    }
  }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.allow_update_menu),
      expression: "storeInfo.allow_update_menu"
    }],
    attrs: {
      "type": "radio",
      "name": "allow_update_menu"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.allow_update_menu, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "allow_update_menu", 0)
      }
    }
  }), _vm._v("\n                      關閉\n                    ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.allow_copy_menu),
      expression: "storeInfo.allow_copy_menu"
    }],
    attrs: {
      "type": "radio",
      "name": "allow_copy_menu"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.allow_copy_menu, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "allow_copy_menu", 1)
      }
    }
  }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.allow_copy_menu),
      expression: "storeInfo.allow_copy_menu"
    }],
    attrs: {
      "type": "radio",
      "name": "allow_copy_menu"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.allow_copy_menu, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "allow_copy_menu", 0)
      }
    }
  }), _vm._v("\n                      關閉\n                    ")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("銷售折扣組合(紅配綠)菜單分類顯示")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    若開啟，菜單分類會再新增「紅區」、「綠區」，提升活動能見度！\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_ab_block_type),
      expression: "storeInfo.menu_ab_block_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menu_ab_block_type"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_ab_block_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_ab_block_type", 1)
      }
    }
  }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_ab_block_type),
      expression: "storeInfo.menu_ab_block_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menu_ab_block_type"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.menu_ab_block_type, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_ab_block_type", 0)
      }
    }
  }), _vm._v("\n                      關閉\n                    ")])])])])])]), _vm._v(" "), (_vm.getRoleType === 99 && _vm.$route.name === 'crStore') ? _c('div', [_c('h4', {
    staticClass: "text-left mb-3"
  }, [_vm._v("菜單管理")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.menuStore),
      expression: "copyInfo.menuStore"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.copyInfo.menuStore, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "menuStore", false)
      }
    }
  }), _vm._v("\n                      自訂\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.menuStore),
      expression: "copyInfo.menuStore"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.copyInfo.menuStore, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "menuStore", true)
      }
    }
  }), _vm._v("\n                      複製\n                    ")])])]), _vm._v(" "), _c('multiselect', {
    class: [
      'flex-grow-1 ml-md',
      {
        'visibility-hidden': !_vm.copyInfo.menuStore
      }
    ],
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "allow-empty": false,
      "options": _vm.storeBrief
    },
    model: {
      value: (_vm.copyInfo.menuStoreId),
      callback: function($$v) {
        _vm.$set(_vm.copyInfo, "menuStoreId", $$v)
      },
      expression: "copyInfo.menuStoreId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.productAlias),
      expression: "copyInfo.productAlias"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.copyInfo.productAlias, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "productAlias", false)
      }
    }
  }), _vm._v("\n                      自訂\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.productAlias),
      expression: "copyInfo.productAlias"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.copyInfo.productAlias, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "productAlias", true)
      }
    }
  }), _vm._v("\n                      複製\n                    ")])])]), _vm._v(" "), _c('multiselect', {
    class: [
      'flex-grow-1 ml-md',
      {
        'visibility-hidden': !_vm.copyInfo.productAlias
      }
    ],
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "allow-empty": false,
      "options": _vm.storeBrief
    },
    model: {
      value: (_vm.copyInfo.productAliasStoreId),
      callback: function($$v) {
        _vm.$set(_vm.copyInfo, "productAliasStoreId", $$v)
      },
      expression: "copyInfo.productAliasStoreId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.productImage),
      expression: "copyInfo.productImage"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.copyInfo.productImage, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "productImage", false)
      }
    }
  }), _vm._v("\n                      自訂\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyInfo.productImage),
      expression: "copyInfo.productImage"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.copyInfo.productImage, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.copyInfo, "productImage", true)
      }
    }
  }), _vm._v("\n                      複製\n                    ")])])]), _vm._v(" "), _c('multiselect', {
    class: [
      'flex-grow-1 ml-md',
      {
        'visibility-hidden': !_vm.copyInfo.productImage
      }
    ],
    attrs: {
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "allow-empty": false,
      "options": _vm.storeBrief
    },
    model: {
      value: (_vm.copyInfo.productImageStoreId),
      callback: function($$v) {
        _vm.$set(_vm.copyInfo, "productImageStoreId", $$v)
      },
      expression: "copyInfo.productImageStoreId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.binding_class),
      expression: "storeInfo.binding_class"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.storeInfo.binding_class, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "binding_class", true)
      }
    }
  }), _vm._v("\n                      是\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-md flex-shrink-0"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.binding_class),
      expression: "storeInfo.binding_class"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.storeInfo.binding_class, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "binding_class", false)
      }
    }
  }), _vm._v("\n                      否\n                    ")])])])])]), _vm._v(" "), (_vm.storeInfo.binding_class) ? _c('div', {
    staticClass: "text-left mb-3"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              請選擇要加入的門市群組，若後續需異動請至菜單建置-門市群組。\n            ")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.binding_class) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(41), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "選擇要加入的群組名稱",
      "placeholder": "選擇要加入的群組名稱",
      "label": "label",
      "track-by": "value",
      "options": _vm.bindingClassList,
      "multiple": true
    },
    model: {
      value: (_vm.storeInfo.binding_class_ids),
      callback: function($$v) {
        _vm.$set(_vm.storeInfo, "binding_class_ids", $$v)
      },
      expression: "storeInfo.binding_class_ids"
    }
  })], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('h3', [_vm._v("POS帳號")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPosAccount),
      expression: "isPosAccount"
    }],
    attrs: {
      "type": "radio",
      "name": "sexOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isPosAccount, 1)
    },
    on: {
      "change": function($event) {
        _vm.isPosAccount = 1
      }
    }
  }), _vm._v("\n                是\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPosAccount),
      expression: "isPosAccount"
    }],
    attrs: {
      "type": "radio",
      "name": "sexOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isPosAccount, 0)
    },
    on: {
      "change": function($event) {
        _vm.isPosAccount = 0
      }
    }
  }), _vm._v("\n                否\n              ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (parseInt(_vm.isPosAccount, 10) === 1 && _vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newPosAccount
    }
  }, [_vm._v("綁定POS帳號")]), _vm._v(" "), _c('div', {
    staticClass: " table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(43), _vm._v(" "), _vm._l((_vm.posList), function(item, index) {
    return _c('tbody', {
      staticClass: "even"
    }, [_c('tr', [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      class: [
        'input-group has-feedback',
        item.account && !_vm.repeatPosAccount(item.account) && item.vaildSingleAccount ? 'has-success' : 'has-error'
      ]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.account),
        expression: "item.account"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.account)
      },
      on: {
        "focusout": function($event) {
          return _vm.checkPosSingleAccount(item, index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "account", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: ['form-control-feedback', item.account && !_vm.repeatPosAccount(item.account) && item.vaildSingleAccount ? 'fa fa-check' : 'fa fa-times']
    })])]), _vm._v(" "), _c('td', [_c('div', {
      class: [' input-group has-feedback', item.password ? 'has-success' : 'has-error']
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.password),
        expression: "item.password"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "password", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: ['form-control-feedback', item.password ? 'fa fa-check' : 'fa fa-times']
    })])]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.pos_vendor_id),
        expression: "item.pos_vendor_id"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": item.pos_account_id
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "pos_vendor_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.posBrief), function(pos, k) {
      return _c('option', {
        key: k,
        domProps: {
          "value": pos.value
        }
      }, [_vm._v("\n                        " + _vm._s(pos.label) + "\n                      ")])
    }), 0)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.role_type),
        expression: "item.role_type"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": item.pos_account_id
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "role_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "10"
      }
    }, [_vm._v("公版")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("特定POS")])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_active),
        expression: "item.is_active"
      }],
      attrs: {
        "type": "radio",
        "name": 'active' + index
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(item.is_active, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_active", 0)
        }
      }
    }), _vm._v("\n                          關閉\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_active),
        expression: "item.is_active"
      }],
      attrs: {
        "type": "radio",
        "name": 'active' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(item.is_active, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_active", 1)
        }
      }
    }), _vm._v("\n                          啟用\n                        ")])])])]), _vm._v(" "), _c('td', [(!item.pos_account_id) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.deletePosAccount(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length && _vm.$route.name !== 'upStore') ? _c('div', [_c('h3', [_vm._v("廣告設定")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length && _vm.$route.name !== 'upStore') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopy),
      expression: "isCopy"
    }],
    attrs: {
      "type": "radio",
      "name": "copyOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isCopy, "1")
    },
    on: {
      "change": function($event) {
        _vm.isCopy = "1"
      }
    }
  }), _vm._v("\n                複製\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopy),
      expression: "isCopy"
    }],
    attrs: {
      "type": "radio",
      "name": "copyOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isCopy, "0")
    },
    on: {
      "change": function($event) {
        _vm.isCopy = "0"
      }
    }
  }), _vm._v("\n                自訂\n              ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isCopy == 1 && _vm.storeBrief.length && _vm.$route.name !== 'upStore') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(45), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyBannerTypeList),
      expression: "copyBannerTypeList"
    }],
    attrs: {
      "type": "radio",
      "name": "copyBannerTypeList"
    },
    domProps: {
      "value": [12],
      "checked": _vm._q(_vm.copyBannerTypeList, [12])
    },
    on: {
      "change": function($event) {
        _vm.copyBannerTypeList = [12]
      }
    }
  }), _vm._v("\n                橫幅廣告\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyBannerTypeList),
      expression: "copyBannerTypeList"
    }],
    attrs: {
      "type": "radio",
      "name": "copyBannerTypeList"
    },
    domProps: {
      "value": [41],
      "checked": _vm._q(_vm.copyBannerTypeList, [41])
    },
    on: {
      "change": function($event) {
        _vm.copyBannerTypeList = [41]
      }
    }
  }), _vm._v("\n                蓋板廣告\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyBannerTypeList),
      expression: "copyBannerTypeList"
    }],
    attrs: {
      "type": "radio",
      "name": "copyBannerTypeList"
    },
    domProps: {
      "value": [12, 41],
      "checked": _vm._q(_vm.copyBannerTypeList, [12, 41])
    },
    on: {
      "change": function($event) {
        _vm.copyBannerTypeList = [12, 41]
      }
    }
  }), _vm._v("\n                兩者\n              ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isCopy === 1 || _vm.isCopy === '1') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(46), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyStoreSelect),
      expression: "copyStoreSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.copyStoreSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 3),
      expression: "storeMethod === 3"
    }],
    staticClass: "box-body form"
  }, [_vm._m(47), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(48), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_start_day),
      expression: "storeInfo.order_start_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.order_start_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_start_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(49), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_tolerance_day),
      expression: "storeInfo.order_tolerance_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.order_tolerance_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_tolerance_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(50), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.auto_reject_order_reserve_m),
      expression: "storeInfo.auto_reject_order_reserve_m"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.auto_reject_order_reserve_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "auto_reject_order_reserve_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('br'), _vm._v(" "), ((_vm.getDenyList.indexOf(331) < 0)) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(52), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "orderOption",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.orderStatusSelect, "10")
    },
    on: {
      "change": function($event) {
        _vm.orderStatusSelect = "10"
      }
    }
  }), _vm._v("\n                  接單中\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "orderOption",
      "value": "20"
    },
    domProps: {
      "checked": _vm._q(_vm.orderStatusSelect, "20")
    },
    on: {
      "change": function($event) {
        _vm.orderStatusSelect = "20"
      }
    }
  }), _vm._v("\n                  不接單\n                ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), ((_vm.getDenyList.indexOf(331) < 0)) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(53), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_status_reason),
      expression: "storeInfo.order_status_reason"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.storeInfo.order_status_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_status_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(54), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.auto_reject_order_m),
      expression: "storeInfo.auto_reject_order_m"
    }],
    ref: "rejectTime",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.storeInfo.auto_reject_order_m)
    },
    on: {
      "keyup": _vm.verityRejectTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "auto_reject_order_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(55), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_preparing_allow_order),
      expression: "storeInfo.is_preparing_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isPreparingAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_preparing_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_preparing_allow_order", 1)
      }
    }
  }), _vm._v("\n                  可下單\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_preparing_allow_order),
      expression: "storeInfo.is_preparing_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isPreparingAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_preparing_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_preparing_allow_order", 0)
      }
    }
  }), _vm._v("\n                  不可下單\n                ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(56), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_close_allow_order),
      expression: "storeInfo.is_close_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isCloseAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_close_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_close_allow_order", 1)
      }
    }
  }), _vm._v("\n                  可下單\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_close_allow_order),
      expression: "storeInfo.is_close_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isCloseAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_close_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_close_allow_order", 0)
      }
    }
  }), _vm._v("\n                  不可下單\n                ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(57), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_start_time_m),
      expression: "storeInfo.order_start_time_m"
    }],
    ref: "startTime",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.storeInfo.order_start_time_m)
    },
    on: {
      "keyup": _vm.verityStartTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_start_time_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(58), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_end_time_m),
      expression: "storeInfo.order_end_time_m"
    }],
    ref: "endTime",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.storeInfo.order_end_time_m)
    },
    on: {
      "keyup": _vm.verityEndTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_end_time_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 4),
      expression: "storeMethod === 4"
    }],
    staticClass: "box-body form"
  }, [_vm._m(59), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("付款類型")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', {
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("支援與否")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                開啟狀態\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    若無法調整開啟狀態表示門市尚未開通此支付別，如需啟用請洽你訂團隊。\n                  ")])], 1)]), _vm._v(" "), (_vm.getRoleType === 99) ? [_c('td', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("線上key (自取、外送)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("線下key (內用、內用-桌邊掃碼)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "150px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "150px"
    }
  })] : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_vm._v("\n                備註 (顯示在購物車頁面上，消費者可查看)\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(60)], 1)])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tradeInfo), function(tradeType, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊")]), _vm._v("\n                " + _vm._s(tradeType.name) + "\n              ")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_support),
        expression: "tradeType.is_support"
      }],
      attrs: {
        "disabled": _vm.getRoleType === 10,
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_support, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(tradeType, "is_support", "1")
        }
      }
    }), _vm._v("\n                      支援\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_support),
        expression: "tradeType.is_support"
      }],
      attrs: {
        "disabled": _vm.getRoleType === 10,
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_support, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(tradeType, "is_support", "0")
        }, function($event) {
          return _vm.clickClose('tradeType', tradeType.is_default, index)
        }]
      }
    }), _vm._v("\n                      不支援\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_enable),
        expression: "tradeType.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "1",
        "disabled": tradeType.is_support == 0
      },
      domProps: {
        "checked": _vm._q(tradeType.is_enable, "1")
      },
      on: {
        "input": function($event) {
          _vm.reload = true
        },
        "change": function($event) {
          return _vm.$set(tradeType, "is_enable", "1")
        }
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': tradeType.is_support == 0
      }
    }, [_vm._v("\n                        開啟\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_enable),
        expression: "tradeType.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0",
        "disabled": tradeType.is_support == 0
      },
      domProps: {
        "checked": _vm._q(tradeType.is_enable, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(tradeType, "is_enable", "0")
        }, function($event) {
          return _vm.clickClose('tradeType', tradeType.is_default, index)
        }]
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': tradeType.is_support == 0
      }
    }, [_vm._v("\n                        關閉\n                      ")])])])])]), _vm._v(" "), (_vm.getRoleType === 99) ? [_vm._l((['online', 'offline']), function(groupType, i) {
      return _c('td', {
        key: i
      }, [(tradeType.meta) ? [(tradeType.meta[groupType == 'online' ? 'delete_key' : 'delete_offline_key']) ? _c('div', {
        staticClass: "text-danger"
      }, [_c('small', {
        staticClass: "text-w-600"
      }, [_vm._v("＊移除先前設定")])]) : _vm._e(), _vm._v(" "), (tradeType.meta[groupType == 'online' ? 'use_key' : 'use_offline_key'] == 1 && !tradeType.meta[groupType == 'online' ? 'delete_key' : 'delete_offline_key']) ? _c('div', [_vm._v("\n                      已設定\n                      "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "btn btn-default",
        on: {
          "click": function($event) {
            tradeType.meta[groupType == 'online' ? 'use_key' : 'use_offline_key'] = 2
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            _vm.reload = true;
            tradeType.meta[groupType == 'online' ? 'delete_key' : 'delete_offline_key'] = 1;
            tradeType.meta[groupType == 'online' ? 'use_key' : 'use_offline_key'] = 2
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _c('div', _vm._l((tradeType.meta.group[groupType]), function(value, key) {
        return _c('div', {
          key: key
        }, [_c('span', {
          staticClass: "text-w-600"
        }, [_vm._v(_vm._s(key) + "：")]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tradeType.meta.group[groupType][key]),
            expression: "tradeType.meta.group[groupType][key]"
          }],
          staticClass: "form-control",
          attrs: {
            "placeholder": "",
            "type": "text",
            "disabled": groupType == 'offline' && !tradeType.check_offline
          },
          domProps: {
            "value": (tradeType.meta.group[groupType][key])
          },
          on: {
            "input": [function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(tradeType.meta.group[groupType], key, $event.target.value)
            }, function($event) {
              _vm.reload = true;
              tradeType.meta[groupType == 'online' ? 'use_key' : 'use_offline_key'] = 2
            }]
          }
        })])
      }), 0)] : _vm._e()], 2)
    }), _vm._v(" "), _c('td', [(tradeType.custom_config) ? _c('div', _vm._l((tradeType.custom_config.key), function(tradeValue, key) {
      return _c('div', {
        key: key
      }, [_c('span', {
        staticClass: "text-w-600"
      }, [_vm._v(_vm._s(key) + "：")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tradeType.custom_config.key[key]),
          expression: "tradeType.custom_config.key[key]"
        }],
        staticClass: "form-control",
        attrs: {
          "placeholder": "",
          "type": "text"
        },
        domProps: {
          "value": (tradeType.custom_config.key[key])
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tradeType.custom_config.key, key, $event.target.value)
          }, function($event) {
            _vm.reload = true
          }]
        }
      })])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [(tradeType.meta || tradeType.custom_config) ? _c('div', [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v("金流帳戶統一編號")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.ein),
        expression: "tradeType.ein"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "",
        "type": "text",
        "maxlength": "8"
      },
      domProps: {
        "value": (tradeType.ein)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tradeType, "ein", $event.target.value)
        }, function($event) {
          return _vm.verityTradeEin(index)
        }]
      }
    })]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.remark),
        expression: "tradeType.remark"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (tradeType.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tradeType, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v("\n                  " + _vm._s(tradeType.remark ? tradeType.remark.length : 0) + "/" + _vm._s(_vm.remarkMaxlength) + "\n                ")])])], 2)
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(62), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("內用-桌邊掃碼")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_cash_pay_after_meal),
      expression: "tableNumber.is_cash_pay_after_meal"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.tableNumber.is_cash_pay_after_meal, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "is_cash_pay_after_meal", 0)
      }
    }
  }), _vm._v("\n                      餐前付款\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_cash_pay_after_meal),
      expression: "tableNumber.is_cash_pay_after_meal"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.tableNumber.is_cash_pay_after_meal, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "is_cash_pay_after_meal", 1)
      }
    }
  }), _vm._v("\n                      餐後付款\n                    ")])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.info) ? _c('div', [_c('h3', [_vm._v("付款方式與取餐金額")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addExceptionTrade
    }
  }, [_vm._v("\n          新增限制\n        ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.exceptionTradeList.length) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(63), _vm._v(" "), _c('tbody', _vm._l((_vm.exceptionTradeList), function(exceptionTrade, eIndex) {
    return _c('tr', {
      key: eIndex
    }, [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.delivery_type),
        expression: "exceptionTrade.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exceptionTrade, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.deliveryInfo), function(delivery, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v("\n                    " + _vm._s(delivery.label) + "\n                  ")])
    }), _vm._v(" "), (exceptionTrade.delivery) ? _c('option', {
      domProps: {
        "value": exceptionTrade.delivery_type
      }
    }, [_vm._v(_vm._s(exceptionTrade.delivery))]) : _vm._e()], 2)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.trade_type),
        expression: "exceptionTrade.trade_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exceptionTrade, "trade_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_vm._l((_vm.tradeList), function(trade, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": trade.value
        }
      }, [_vm._v("\n                    " + _vm._s(trade.label) + "\n                  ")])
    }), _vm._v(" "), (exceptionTrade.trade) ? _c('option', {
      domProps: {
        "value": exceptionTrade.trade_type
      }
    }, [_vm._v(_vm._s(exceptionTrade.trade))]) : _vm._e()], 2)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.start_money),
        expression: "exceptionTrade.start_money"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (exceptionTrade.start_money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exceptionTrade, "start_money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.end_money),
        expression: "exceptionTrade.end_money"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (exceptionTrade.end_money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exceptionTrade, "end_money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm._f("deliveryName")(exceptionTrade.delivery_type)) + "\n                "), (exceptionTrade.start_money) ? _c('span', [_vm._v("\n                  " + _vm._s(exceptionTrade.start_money) + " 元以上\n                ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.start_money && exceptionTrade.end_money) ? _c('span', [_vm._v("\n                  ～\n                ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.end_money) ? _c('span', [_vm._v("\n                  " + _vm._s(exceptionTrade.end_money) + " 元以下\n                ")]) : _vm._e(), _vm._v("\n                不可用" + _vm._s(_vm._f("tradeName")(exceptionTrade.trade_type)) + "付款\n              ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.exceptionTradeList, eIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 5),
      expression: "storeMethod === 5"
    }],
    staticClass: "box-body form"
  }, [_vm._m(64), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(65), _vm._v(" "), _c('tbody', _vm._l((_vm.takeTimeInfo), function(takeTime, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideDeliveryType.includes(takeTime.take_type)),
        expression: "!hideDeliveryType.includes(takeTime.take_type)"
      }],
      key: i
    }, [_c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊")]), _vm._v("\n                " + _vm._s(_vm._f("deliveryName")(takeTime.take_type)) + "\n              ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (takeTime.prepare_time_seg),
        expression: "takeTime.prepare_time_seg"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (takeTime.prepare_time_seg)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(takeTime, "prepare_time_seg", $event.target.value)
        }
      }
    }), _vm._v("\n                分鐘\n              ")]), _vm._v(" "), _c('td', [(takeTime.take_type < 3 && _vm.$route.name === 'upStore') ? _c('span', [_vm._v("\n                  不需設定\n                ")]) : (takeTime.take_type === 21) ? _c('span', [_vm._v("\n                  不需設定\n                ")]) : _c('div', {
      staticClass: "flex align-center"
    }, [_c('div', {
      staticClass: "input-group-btn flex w-auto"
    }, [_c('button', {
      staticClass: "btn btn-default w-36px",
      attrs: {
        "disabled": !takeTime.take_time_seg
      },
      on: {
        "click": function($event) {
          return _vm.setTakeTime('minus', takeTime)
        }
      }
    }, [_vm._v("\n                      -\n                    ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (takeTime.take_time_seg),
        expression: "takeTime.take_time_seg"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (takeTime.take_time_seg)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(takeTime, "take_time_seg", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default w-36px",
      on: {
        "click": function($event) {
          return _vm.setTakeTime('add', takeTime)
        }
      }
    }, [_vm._v("\n                      +\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "m-l-5"
    }, [_vm._v("分鐘")])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addProcessTime
    }
  }, [_vm._v("\n          新增某時段的製作時間\n        ")])]), _vm._v(" "), _vm._l((_vm.processTimeList), function(process, pIndex) {
    return _c('div', {
      key: pIndex,
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.processTimeList, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(66, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增月份",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.month,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.month),
        callback: function($$v) {
          _vm.$set(process, "month", $$v)
        },
        expression: "process.month"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(67, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.value_type),
        expression: "process.value_type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(process, "value_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearProcess(process)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("日期")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("星期")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(68, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(69, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "tag-placeholder": "數字為1~31",
        "placeholder": "新增日期 (格式為數字1~31)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.monthDay,
        "multiple": false,
        "taggable": true,
        "id": 'process-start-' + pIndex
      },
      on: {
        "tag": _vm.addStartMonthDayTag
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(70, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(71, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "tag-placeholder": "數字為1~31",
        "placeholder": "新增日期 (格式為數字1~31)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.monthDay,
        "multiple": false,
        "taggable": true
      },
      on: {
        "tag": _vm.addEndMonthDayTag
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(72, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "選擇取餐類型",
        "label": "label",
        "track-by": "value",
        "options": _vm.deliveryTypeOption,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.delivery_type),
        callback: function($$v) {
          _vm.$set(process, "delivery_type", $$v)
        },
        expression: "process.delivery_type"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addItemTime(process)
        }
      }
    }, [_vm._v("\n            加入時間\n          ")])]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(73, true), _vm._v(" "), _c('tbody', _vm._l((process.item_list), function(item, iIndex) {
      return _c('tr', {
        key: iIndex
      }, [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.process_time),
          expression: "item.process_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "",
          "type": "text"
        },
        domProps: {
          "value": (item.process_time)
        },
        on: {
          "keypress": _vm.returnNum,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "process_time", $event.target.value)
          }
        }
      }), _vm._v("  分鐘\n              ")]), _vm._v(" "), _c('td', [(iIndex > 0) ? _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(process.item_list, iIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()])])
    }), 0)])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 6),
      expression: "storeMethod === 6"
    }],
    staticClass: "box-body form"
  }, [_vm._m(74), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(75), _vm._v(" "), (_vm.getRoleType === 10) ? _c('div', {
    staticClass: "text-left m-b-15"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("若要啟用特定取餐方式請按右上角聯絡客服")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐類型")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', [_vm._v("支援與否")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("開啟狀態")]), _vm._v(" "), _c('td', [_vm._v("\n                預設\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                    購物車預設的取餐方式。開啟狀態為 \"開啟\" 的取餐方式才能設為預設。\n                  ")])], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("消費金額與距離門檻")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(76)], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("備註")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(77)], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("取餐提醒")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(78)], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideDeliveryType.includes(deliveryWays.take_type)),
        expression: "!hideDeliveryType.includes(deliveryWays.take_type)"
      }],
      key: i
    }, [_c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊")]), _vm._v("\n              " + _vm._s(_vm._f("deliveryName")(deliveryWays.take_type)) + "\n            ")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_support),
        expression: "deliveryWays.is_support"
      }],
      attrs: {
        "disabled": _vm.getRoleType === 10,
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_support, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_support", "1")
        }
      }
    }), _vm._v("\n                    支援\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_support),
        expression: "deliveryWays.is_support"
      }],
      attrs: {
        "disabled": _vm.getRoleType === 10,
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_support, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_support", "0")
        }, function($event) {
          return _vm.clickClose('deliveryWays', true, deliveryWays.is_default, i)
        }]
      }
    }), _vm._v("\n                    不支援\n                  ")])])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_enable),
        expression: "deliveryWays.is_enable"
      }],
      attrs: {
        "type": "radio",
        "disabled": deliveryWays.is_support === 0,
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_enable, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_enable", "1")
        }
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': deliveryWays.is_support == 0
      }
    }, [_vm._v("\n                      開啟\n                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_enable),
        expression: "deliveryWays.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0",
        "disabled": deliveryWays.is_support === 0
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_enable, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_enable", "0")
        }, function($event) {
          return _vm.clickClose('deliveryWays', false, deliveryWays.is_default, i)
        }]
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': deliveryWays.is_support == 0
      }
    }, [_vm._v("\n                      關閉\n                    ")])])])])]), _vm._v(" "), _c('td', [(deliveryWays.take_type !== 21) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_default),
        expression: "deliveryWays.is_default"
      }],
      attrs: {
        "type": "radio",
        "value": "1",
        "disabled": parseInt(deliveryWays.is_support, 10) === 0 || parseInt(deliveryWays.is_enable, 10) === 0
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_default, "1")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_default", "1")
        }, function($event) {
          return _vm.checkDefault(deliveryWays.take_type)
        }]
      }
    })]) : _vm._e()]), _vm._v(" "), (deliveryWays.take_type !== 3) ? _c('td', [_vm._v("\n              滿\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.price),
        expression: "deliveryWays.price"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text",
        "disabled": _vm.getRoleType === 10 && deliveryWays.is_support === 0
      },
      domProps: {
        "value": (deliveryWays.price)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "price", $event.target.value)
        }
      }
    }), _vm._v("\n              元即可" + _vm._s(_vm._f("deliveryName")(deliveryWays.take_type)) + "\n            ")]) : _vm._e(), _vm._v(" "), (deliveryWays.take_type === 3) ? _c('td', [_c('delivery-limit', {
      attrs: {
        "store-info": _vm.storeInfo,
        "delivery-ways": deliveryWays,
        "delivery-ways-info": _vm.deliveryWaysInfo,
        "delivery-other": _vm.deliveryOther
      },
      on: {
        "update:deliveryWaysInfo": function($event) {
          _vm.deliveryWaysInfo = $event
        },
        "update:deliveryOther": function($event) {
          _vm.deliveryOther = $event
        },
        "update:storeInfo": function($event) {
          _vm.storeInfo = $event
        },
        "update:deliveryWays": function($event) {
          deliveryWays = $event
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.memo),
        expression: "deliveryWays.memo"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "disabled": _vm.getRoleType === 10 && deliveryWays.is_support === 0,
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (deliveryWays.memo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "memo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(deliveryWays.memo.length || 0) + "/" + _vm._s(_vm.remarkMaxlength))])]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.pickup_memo),
        expression: "deliveryWays.pickup_memo"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "disabled": _vm.getRoleType === 10 && deliveryWays.is_support === 0,
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (deliveryWays.pickup_memo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "pickup_memo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(deliveryWays.pickup_memo.length || 0) + "/" + _vm._s(_vm.remarkMaxlength))])])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(79), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "text-left m-b-15"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.addProductItem('search')
      }
    }
  }, [_vm._v("\n            搜尋商品\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.addProductItem('insert')
      }
    }
  }, [_vm._v("\n            新增商品\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "grey darken-1 m-l-5"
  }, [_vm._v("提示：若商品已在菜單中，請優先使用「搜尋商品」")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto m-b-15"
  }, [(!_vm.deliveryExceptionProductSelect) ? _c('div', {
    key: "default-mode"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.checkDeliveryExceptionProductList,
      "data-toggle": "modal",
      "data-target": "#copyModal"
    }
  }, [_vm._v("\n              複製所有排除項目至其他店家\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.deliveryExceptionProductSelect = true
      }
    }
  }, [_vm._v("\n              批次選取\n            ")])]) : _c('div', {
    key: "select-mode"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.deliveryExceptionProductSelect = false
      }
    }
  }, [_vm._v("\n              取消選取\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.deliveryExceptionProductSelectItems.length,
      "data-toggle": "modal",
      "data-target": "#delExceptionModal"
    }
  }, [_vm._v("\n              批次刪除\n            ")])])])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [(_vm.deliveryExceptionProductSelect) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryExceptionProductSelectAll),
      expression: "deliveryExceptionProductSelectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.deliveryExceptionProductSelectAll) ? _vm._i(_vm.deliveryExceptionProductSelectAll, null) > -1 : (_vm.deliveryExceptionProductSelectAll)
    },
    on: {
      "click": function($event) {
        return _vm.selectAllProducts()
      },
      "change": function($event) {
        var $$a = _vm.deliveryExceptionProductSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.deliveryExceptionProductSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.deliveryExceptionProductSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.deliveryExceptionProductSelectAll = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("#")]), _vm._v(" "), _c('td', [_vm._v("類型")]), _vm._v(" "), _c('td', [_vm._v("商品名稱")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td', [_vm._v("狀態")]), _vm._v(" "), _c('td', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', [(_vm.deliveryExceptionProductList.length === 0) ? _c('tr', [_vm._m(84)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.deliveryExceptionProductList), function(item, index) {
    return _c('tr', {
      key: index
    }, [(_vm.deliveryExceptionProductSelect) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selected),
        expression: "item.selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.selected) ? _vm._i(item.selected, null) > -1 : (item.selected)
      },
      on: {
        "change": function($event) {
          var $$a = item.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selected", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.product_type),
        expression: "item.product_type"
      }],
      staticClass: "form-control inline-block",
      attrs: {
        "disabled": item.item_type === 'search' || item.updated
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "product_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("商品")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("套餐")])])]), _vm._v(" "), _c('td', [(item.item_type === 'search') ? _c('multiselect', {
      attrs: {
        "options": _vm.optionsList,
        "searchable": true,
        "allow-empty": true,
        "close-on-select": true,
        "placeholder": "請輸入商品名稱",
        "show-labels": false,
        "multiple": false,
        "label": "name",
        "track-by": "id"
      },
      on: {
        "input": function($event) {
          return _vm.handleProductSelect(item)
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(props) {
          return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
        }
      }], null, true),
      model: {
        value: (item.search_result),
        callback: function($$v) {
          _vm.$set(item, "search_result", $$v)
        },
        expression: "item.search_result"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.product_name),
        expression: "item.product_name"
      }],
      staticClass: "form-control inline-block deliveryExceptionInput",
      attrs: {
        "type": "text",
        "disabled": item.updated,
        "placeholder": "請輸入商品名稱"
      },
      domProps: {
        "value": (item.product_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "product_name", $event.target.value)
        }
      }
    })], 1), _vm._v(" "), _c('td', [(item.item_type === 'search') ? _c('multiselect', {
      attrs: {
        "options": _vm.optionsList,
        "searchable": true,
        "allow-empty": true,
        "close-on-select": true,
        "placeholder": "請輸入商品料號",
        "show-labels": false,
        "multiple": false,
        "label": "id",
        "track-by": "id"
      },
      on: {
        "input": function($event) {
          return _vm.handleProductSelect(item)
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(props) {
          return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
        }
      }], null, true),
      model: {
        value: (item.search_result),
        callback: function($$v) {
          _vm.$set(item, "search_result", $$v)
        },
        expression: "item.search_result"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.vendor_custom_id),
        expression: "item.vendor_custom_id"
      }],
      staticClass: "form-control inline-block deliveryExceptionInput",
      attrs: {
        "type": "text",
        "disabled": item.item_type === 'search' || item.updated,
        "placeholder": "請輸入商品料號"
      },
      domProps: {
        "value": (item.vendor_custom_id)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "vendor_custom_id", $event.target.value)
        }
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_enabled),
        expression: "item.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'status_' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(item.is_enabled, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_enabled", 1)
        }
      }
    }), _vm._v("開啟\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_enabled),
        expression: "item.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'status_' + index
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(item.is_enabled, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_enabled", 0)
        }
      }
    }), _vm._v("關閉\n                    ")])])])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteProductItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.shippingInfo.is_support && _vm.shippingInfo.is_enable) ? _c('shipping-form', {
    ref: "shippingInfo",
    attrs: {
      "show-vendor-id": _vm.apiTypeSelect == 1,
      "store-info": _vm.storeInfo
    },
    on: {
      "update:store-info": function($event) {
        _vm.storeInfo = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isEnableOnSite) ? _c('div', [_c('h3', [_vm._v("桌邊掃碼")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(85), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.sub_delivery_type),
      expression: "tableNumber.sub_delivery_type"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.tableNumber.sub_delivery_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "sub_delivery_type", 1)
      }
    }
  }), _vm._v("\n                  叫號取餐\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.sub_delivery_type),
      expression: "tableNumber.sub_delivery_type"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.tableNumber.sub_delivery_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "sub_delivery_type", 2)
      }
    }
  }), _vm._v("\n                  店家送餐\n                ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(86), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_table_no_required),
      expression: "tableNumber.is_table_no_required"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "is_table_no_required", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("非必填")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("必填")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(87), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_table_no_editable),
      expression: "tableNumber.is_table_no_editable"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "is_table_no_editable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不可編輯")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("可編輯")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(88), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.show_table_no),
      expression: "tableNumber.show_table_no"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "show_table_no", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("隱藏")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("顯示")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(89), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return (deliveryWays.take_type === 21) ? _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_allow_guest_order),
        expression: "deliveryWays.is_allow_guest_order"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(deliveryWays.is_allow_guest_order, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_allow_guest_order", 1)
        }
      }
    }), _vm._v("\n                      開啟\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_allow_guest_order),
        expression: "deliveryWays.is_allow_guest_order"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(deliveryWays.is_allow_guest_order, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_allow_guest_order", 0)
        }
      }
    }), _vm._v("\n                      關閉\n                    ")])])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return (deliveryWays.take_type === 21 && deliveryWays.is_allow_guest_order === 1) ? _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(90, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tableNumber.default_login_type),
        expression: "tableNumber.default_login_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tableNumber, "default_login_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("會員")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("訪客")])])])]), _vm._v(" "), _c('br')]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('h3', [_vm._v("排除設定")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('p', [_vm._v("某時間(日期、星期、每月幾號)無法取餐(自取、外送、內用、桌邊掃碼)")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.info) ? _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addExCalendar
    }
  }, [_vm._v("新增店家排除時段設定")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.exceptionCalendar), function(exCalendar, caIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.exceptionCalendar, caIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(91, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exCalendar.delivery_type),
        expression: "exCalendar.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exCalendar, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.deliveryInfo), function(delivery) {
      return _c('option', {
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v(_vm._s(delivery.label))])
    }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExDate(exCalendar)
        }
      }
    }, [_vm._v("加入指定日期")])]), _vm._v(" "), (exCalendar.date_type.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(92, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.date_type), function(item, daIndex) {
      return _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.date),
          expression: "item.date"
        }],
        staticClass: "form-control inline-block",
        attrs: {
          "placeholder": "YYYY-MM-DD",
          "type": "text"
        },
        domProps: {
          "value": (item.date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "date", $event.target.value)
          }
        }
      }), _vm._v("  \n            ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.date_type, daIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExWeekDay(exCalendar)
        }
      }
    }, [_vm._v("加入星期")])]), _vm._v(" "), (exCalendar.week_day.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(93, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.week_day), function(item, weIndex) {
      return _c('tr', [_c('td', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.day),
          expression: "item.day"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.offdaySetting.options.weekDay), function(weekDay) {
        return (weekDay.value) ? _c('option', {
          domProps: {
            "value": weekDay.value
          }
        }, [_vm._v("\n                  " + _vm._s(weekDay.label) + "\n                ")]) : _vm._e()
      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.week_day, weIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExMonthDay(exCalendar)
        }
      }
    }, [_vm._v("加入每月幾號")])]), _vm._v(" "), (exCalendar.month_day.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(94, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.month_day), function(item, moIndex) {
      return _c('tr', [_c('td', [_vm._v("\n              每月"), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.day),
          expression: "item.day"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "DD",
          "type": "text"
        },
        domProps: {
          "value": (item.day)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "day", $event.target.value)
          }
        }
      }), _vm._v("  日\n            ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.month_day, moIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "pickupWarnModal",
    staticClass: "btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#pickupWarnModal"
    }
  }), _vm._v(" "), _vm._m(95)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 7),
      expression: "storeMethod === 7"
    }],
    staticClass: "box-body form"
  }, [_vm._m(96), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow": "inherit"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(97), _vm._v(" "), _c('tbody', _vm._l((_vm.openingInfo), function(weekDay) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(_vm.getWeekDayName(weekDay.week_day)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (weekDay.start),
        expression: "weekDay.start"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (weekDay.start)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(weekDay, 'start', 'end')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(weekDay, "start", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (weekDay.end),
        expression: "weekDay.end"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (weekDay.end)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(weekDay, 'start', 'end')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(weekDay, "end", $event.target.value)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addSpecialDay
    }
  }, [_vm._v("新增指定日期")])]), _vm._v(" "), (_vm.selectSpecialDay.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_vm._m(98), _vm._v(" "), _vm._m(99), _vm._v(" "), _c('div', {
    staticClass: "table-responsive specialDayCalendarTable-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary sticky-header"
  }, [_c('tr', [_c('td', [_vm._v("指定日期")]), _vm._v(" "), _c('td', [_vm._v("營業時間")]), _vm._v(" "), _c('td', [_vm._v("打烊時間")]), _vm._v(" "), _c('td', [_vm._v("備註\n                  "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(100)], 1)]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectSpecialDay), function(item, daIndex) {
    return _c('tr', [_c('td', {
      staticClass: "date-picker-cell"
    }, [_c('div', {
      staticClass: "calendar-container"
    }, [(item.showSpecialDayCalendar) ? _c('div', {
      staticClass: "calendar",
      on: {
        "blur": function($event) {
          item.showSpecialDayCalendar = false
        }
      }
    }, [_c('FunctionalCalendar', {
      attrs: {
        "is-multiple-date-picker": true,
        "limits": _vm.calendarLimits
      },
      on: {
        "dayClicked": function($event) {
          return _vm.specialDayCalendarSelected(daIndex, $event)
        }
      },
      model: {
        value: (_vm.tempSpecialDayCalendar),
        callback: function($$v) {
          _vm.tempSpecialDayCalendar = $$v
        },
        expression: "tempSpecialDayCalendar"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "calenderClose"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-xs btn-close",
      on: {
        "click": function($event) {
          item.showSpecialDayCalendar = false
        }
      }
    }, [_vm._v("\n                        關閉\n                      ")])])], 1) : _vm._e(), _vm._v(" "), _c('multiselect', {
      staticClass: "calendar-multiselect",
      attrs: {
        "tag-placeholder": "格式為YYYY-MM-DD",
        "placeholder": "新增日期 (格式為YYYY-MM-DD)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.date,
        "multiple": true,
        "optionsLimit": 0,
        "hideSelected": true
      },
      on: {
        "remove": function($event) {
          return _vm.removeTag('specialDay', daIndex, _vm.val)
        },
        "open": function($event) {
          return _vm.openSpecialDayCalendar(daIndex)
        }
      },
      model: {
        value: (item.calendar_list),
        callback: function($$v) {
          _vm.$set(item, "calendar_list", $$v)
        },
        expression: "item.calendar_list"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.start_time),
        expression: "item.start_time"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (item.start_time)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "start_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.end_time),
        expression: "item.end_time"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (item.end_time)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "end_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "remark-cell"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "1",
        "maxlength": _vm.specialDayRemarkMaxlength
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s((item.remark || '').length) + "/" + _vm._s(_vm.specialDayRemarkMaxlength))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.selectSpecialDay, daIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(101), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(102), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_off_allow_order),
      expression: "storeInfo.is_off_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isOffAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_off_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_off_allow_order", 1)
      }
    }
  }), _vm._v("可下單\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_off_allow_order),
      expression: "storeInfo.is_off_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isOffAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_off_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_off_allow_order", 0)
      }
    }
  }), _vm._v("不可下單\n                ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            指定日期\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "calendar-container"
  }, [(_vm.showCalendar) ? _c('div', {
    staticClass: "calendar",
    on: {
      "blur": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_c('FunctionalCalendar', {
    attrs: {
      "is-multiple-date-picker": true,
      "limits": _vm.calendarLimits
    },
    on: {
      "dayClicked": _vm.calendarSelected
    },
    model: {
      value: (_vm.selectDate),
      callback: function($$v) {
        _vm.selectDate = $$v
      },
      expression: "selectDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calenderClose"
  }, [(_vm.info) ? _c('button', {
    staticClass: "btn btn-primary btn-xs btn-close",
    on: {
      "click": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_vm._v("\n                關閉\n              ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('multiselect', {
    staticClass: "calendar-multiselect",
    attrs: {
      "tag-placeholder": "格式為YYYY-MM-DD",
      "placeholder": "新增日期 (格式為YYYY-MM-DD)",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdaySetting.options.date,
      "multiple": true,
      "optionsLimit": 0,
      "hideSelected": true
    },
    on: {
      "remove": function($event) {
        return _vm.removeTag('date', 0, $event)
      },
      "open": _vm.openDateCalendar
    },
    model: {
      value: (_vm.offdaySetting.date),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "date", $$v)
      },
      expression: "offdaySetting.date"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            每週幾\n          ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "placeholder": "新增日期",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdayWeekDayOptions,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.offdaySetting.weekDay),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "weekDay", $$v)
      },
      expression: "offdaySetting.weekDay"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            每月幾號\n          ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "數字為1~31",
      "placeholder": "新增日期 (格式為數字1~31)",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdayMonthDayOptions,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addMonthDayTag
    },
    model: {
      value: (_vm.offdaySetting.monthDay),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "monthDay", $$v)
      },
      expression: "offdaySetting.monthDay"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 8),
      expression: "storeMethod === 8"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_vm._m(103), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(104), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticSelect),
      expression: "plasticSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.plasticSelect = "1"
      }
    }
  }), _vm._v("開啟（此功能需於菜單上架塑膠袋商品方可支援）\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticSelect),
      expression: "plasticSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.plasticSelect = "0"
      }
    }
  }), _vm._v("關閉\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              塑膠袋數量可自行調整\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text",
    domProps: {
      "textContent": _vm._s('消費者可否在購物車中自行調整塑膠袋的數量')
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: " text-left flex align-center"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticAmountAdjustable),
      expression: "plasticAmountAdjustable"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticAmountAdjustable",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticAmountAdjustable, "1")
    },
    on: {
      "change": function($event) {
        _vm.plasticAmountAdjustable = "1"
      }
    }
  }), _vm._v("開啟\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticAmountAdjustable),
      expression: "plasticAmountAdjustable"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticAmountAdjustable",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticAmountAdjustable, "0")
    },
    on: {
      "change": function($event) {
        _vm.plasticAmountAdjustable = "0"
      }
    }
  }), _vm._v("關閉\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(105), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.trim",
      value: (_vm.storeInfo.plastic_unit),
      expression: "storeInfo.plastic_unit",
      modifiers: {
        "number": true,
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.plastic_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "plastic_unit", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            預設勾選塑膠袋\n          ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "placeholder": "選擇取餐方式",
      "label": "label",
      "track-by": "value",
      "options": _vm.deliveryInfo,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.deliveryWayPlastic),
      callback: function($$v) {
        _vm.deliveryWayPlastic = $$v
      },
      expression: "deliveryWayPlastic"
    }
  })], 1)]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 10),
      expression: "storeMethod === 10"
    }],
    staticClass: "box-body form"
  }, [_vm._m(106), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printerStoreList.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(107), _vm._v(" "), _c('tbody', _vm._l((_vm.printerStoreList), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                出單機" + _vm._s(printer.printer_id) + "號 (" + _vm._s(printer.printer_id) + ")\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(printer.binding_name) + " (" + _vm._s(printer.binding_id) + ")\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.printerType(printer.printer_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_identity))]), _vm._v(" "), _c('td', [(printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [(printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#editModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(108), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerSelect),
      expression: "printerSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.printerSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("使用現有")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.printerSelect === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(109), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerInfo.identity),
      expression: "printerInfo.identity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.printerInfo.identity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerInfo, "identity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.printerSelect === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(110), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerInfo.type),
      expression: "printerInfo.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.printerInfo, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("W牌出單機(1)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("F牌出單機(2)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("F牌貼紙機(3)")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.printerSelect === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(111), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrinterSelect),
      expression: "isPrinterSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isPrinterSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.printerList), function(printer) {
    return _c('option', {
      domProps: {
        "value": printer.printer_id
      }
    }, [_vm._v(_vm._s(printer.printer_identity))])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.info && _vm.storeMethod === 10) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkPrinter
    }
  }, [_vm._v("\n        綁定\n      ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticClass: "m-t-20"
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printerLayoutSetting.length) ? _c('div', [_vm._m(112), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(113), _vm._v(" "), _c('tbody', _vm._l((_vm.printerLayoutSetting), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(printer.layout_name) + "\n                ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.trigger_type),
        expression: "printer.trigger_type"
      }],
      attrs: {
        "type": "radio",
        "name": 'triggerType' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(printer.trigger_type, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "trigger_type", 1)
        }
      }
    }), _vm._v("手動\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.trigger_type),
        expression: "printer.trigger_type"
      }],
      attrs: {
        "type": "radio",
        "name": 'triggerType' + index
      },
      domProps: {
        "value": 2,
        "checked": _vm._q(printer.trigger_type, 2)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "trigger_type", 2)
        }
      }
    }), _vm._v("自動\n                    ")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.is_enabled),
        expression: "printer.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'isEnable' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(printer.is_enabled, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "is_enabled", 1)
        }
      }
    }), _vm._v("啟用\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.is_enabled),
        expression: "printer.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'isEnable' + index
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(printer.is_enabled, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "is_enabled", 0)
        }
      }
    }), _vm._v("未啟用\n                    ")])])])])
  }), 0)]), _vm._v(" "), _c('br')])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 11 && _vm.$route.name !== 'crStore'),
      expression: "storeMethod === 11 && $route.name !== 'crStore'"
    }],
    staticClass: "box-body form"
  }, [_vm._m(114), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(115), _vm._v(" "), _c('div', {
    staticClass: "table-responsive m-b-15"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("入口")]), _vm._v(" "), _c('td', [_vm._v("桌號\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                    限10字以內，僅限英數大小寫不可符號，桌號間請使用「，」分隔。\n                  ")])], 1)]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumberUrl.type),
      expression: "tableNumberUrl.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumberUrl, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.enterType), function(item) {
    return _c('option', {
      key: ("enter-" + (item.value)),
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tableNumberUrl.text),
      expression: "tableNumberUrl.text",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control inline-block",
    attrs: {
      "rows": "3",
      "placeholder": "範例：A01,A02,A03..."
    },
    domProps: {
      "value": (_vm.tableNumberUrl.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableNumberUrl, "text", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.exportUrl
    }
  }, [_vm._v("匯出網址")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 12),
      expression: "storeMethod === 12"
    }],
    staticClass: "box-body form"
  }, [_vm._m(116), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(117), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.type),
      expression: "orderCommissionSetting.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.orderCommissionSetting, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("系統費")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("系統費+資訊服務費抽成")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("資訊服務費抽成")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.orderCommissionSetting.type > 1) ? _c('div', {
    staticClass: "text-left"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.orderCommissionSetting.item_list.push(JSON.parse(JSON.stringify(_vm.commissionItemList)))
      }
    }
  }, [_vm._v("\n            新增資訊服務費抽成設定\n          ")])]), _vm._v(" "), _vm._l((_vm.orderCommissionSetting.item_list), function(item, pIndex) {
    return _c('div', {
      key: pIndex,
      class: ['process-time-block', {
        'm-t-10': pIndex !== 0
      }, {
        'overlap': _vm.showOverlapErrorIndex.includes(pIndex)
      }]
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.orderCommissionSetting.item_list, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(118, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ratio),
        expression: "item.ratio"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "輸入數字",
        "type": "number",
        "maxlength": "2"
      },
      domProps: {
        "value": (item.ratio)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ratio", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-addon-icon"
    }, [_vm._v("\n                %\n              ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_vm._m(119, true), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.delivery_type),
        expression: "item.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.supportDeliveryOption), function(delivery) {
      return _c('option', {
        key: ("takeType" + (delivery.value)),
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v("\n                    " + _vm._s(delivery.label) + "\n                  ")])
    })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "table-row"
    }, [_vm._m(120, true), _vm._v(" "), _c('div', {
      staticClass: "table-from"
    }, [_c('date-picker', {
      staticClass: "hide-date-icon",
      attrs: {
        "show-second": false,
        "type": "datetime",
        "valueType": "format",
        "format": "YYYY-MM-DD HH:mm",
        "input-class": "form-control",
        "placeholder": "新增日期 (格式為：YYYY-MM-DD HH:mm)",
        "clearable": false,
        "disabled-time": _vm.notBeforeTodayAddTwoMins,
        "disabled-date": _vm.notBeforeToday
      },
      model: {
        value: (item.start_time),
        callback: function($$v) {
          _vm.$set(item, "start_time", $$v)
        },
        expression: "item.start_time"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "table-row p-t-10"
    }, [_vm._m(121, true), _vm._v(" "), _c('div', {
      staticClass: "table-from"
    }, [_c('date-picker', {
      staticClass: "hide-date-icon",
      attrs: {
        "show-second": false,
        "type": "datetime",
        "valueType": "format",
        "format": "YYYY-MM-DD HH:mm",
        "input-class": "form-control",
        "placeholder": "新增日期 (格式為：YYYY-MM-DD HH:mm)",
        "clearable": false,
        "disabled-time": _vm.notBeforeTodayAddTwoMins,
        "disabled-date": _vm.notBeforeToday
      },
      model: {
        value: (item.end_time),
        callback: function($$v) {
          _vm.$set(item, "end_time", $$v)
        },
        expression: "item.end_time"
      }
    })], 1)])])])
  }), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.orderCommissionSetting.type !== 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(122), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.orderCommissionSetting.has_independent_report, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.orderCommissionSetting, "has_independent_report", _vm._n(1))
      }
    }
  }), _vm._v("\n                是\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.orderCommissionSetting.has_independent_report, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.orderCommissionSetting, "has_independent_report", _vm._n(0))
      }
    }
  }), _vm._v("\n                否\n              ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.orderCommissionSetting.has_independent_report),
      expression: "!orderCommissionSetting.has_independent_report"
    }],
    staticClass: "process-time-block"
  }, [_vm._m(123), _vm._v(" "), _c('div', {
    staticClass: "input-group m-b-15"
  }, [_vm._m(124), _vm._v(" "), _c('div', {
    staticClass: "flex align-center m-l-15 h-34"
  }, [_vm._v("\n              " + _vm._s(_vm.orderCommissionSetting.brand_setting.quota_type === 1 ? '品牌總' : '每間門市') + "額度\n              "), _c('span', {
    staticClass: "m-l-5",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": _vm.orderCommissionSetting.brand_setting.quota_type === 1 ? '整個品牌的作廢訂單總額度，非單一門市值。' : '每間門市都有指定的作廢額度。例如 : 當額度設定為 5 筆時，每間門市都有 5 筆的作廢額度。'
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(125), _vm._v(" "), _c('div', {
    staticClass: "flex align-center m-l-15 h-34"
  }, [_vm._v("\n              " + _vm._s(_vm.brandInvalidQuota) + "\n            ")])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report"
    }],
    staticClass: "input-group"
  }, [_vm._m(126), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.allow_invalid_order_quota),
      expression: "orderCommissionSetting.allow_invalid_order_quota"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.orderCommissionSetting.allow_invalid_order_quota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderCommissionSetting, "allow_invalid_order_quota", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 13),
      expression: "storeMethod === 13"
    }],
    staticClass: "box-body form"
  }, [_vm._m(127), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$route.name === 'upStore' && _vm.storeInfo.shipping_info && _vm.storeInfo.shipping_info.mete_store_id) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(128), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pay_party),
      expression: "pay_party"
    }],
    attrs: {
      "type": "radio",
      "name": "brand",
      "disabled": true
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.pay_party, 2)
    },
    on: {
      "change": function($event) {
        _vm.pay_party = 2
      }
    }
  }), _vm._v("\n                  品牌\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pay_party),
      expression: "pay_party"
    }],
    attrs: {
      "type": "radio",
      "name": "brand",
      "disabled": true
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.pay_party, 1)
    },
    on: {
      "change": function($event) {
        _vm.pay_party = 1
      }
    }
  }), _vm._v("\n                  門市\n                ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(129), _vm._v(" "), _c('tbody', _vm._l((_vm.supportShippingVendor), function(vendor, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm._f("shippingVendorName")(vendor.vendor_code)) + "\n              ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vendor.is_enable),
        expression: "vendor.is_enable"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(vendor.is_enable, 1)
      },
      on: {
        "input": function($event) {
          _vm.reload = true
        },
        "change": function($event) {
          return _vm.$set(vendor, "is_enable", 1)
        }
      }
    }), _vm._v("\n                      啟用\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vendor.is_enable),
        expression: "vendor.is_enable"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(vendor.is_enable, 0)
      },
      on: {
        "input": function($event) {
          _vm.reload = true
        },
        "change": function($event) {
          return _vm.$set(vendor, "is_enable", 0)
        }
      }
    }), _vm._v("\n                      不啟用\n                    ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 14),
      expression: "storeMethod === 14"
    }],
    staticClass: "box-body form"
  }, [_c('h3', {
    domProps: {
      "textContent": _vm._s('服務費設定')
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s('服務費說明')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text",
    domProps: {
      "textContent": _vm._s('填寫資訊會顯示在前台畫面中。例本店收取服務費10%。')
    }
  })], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.service_fee_description),
      expression: "storeInfo.service_fee_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "服務費說明設定",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.service_fee_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "service_fee_description", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 15),
      expression: "storeMethod === 15"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_vm._m(130), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(131), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.showTablewareStrawOption),
      expression: "showTablewareStrawOption",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "showTablewareStrawOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.showTablewareStrawOption, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.showTablewareStrawOption = _vm._n(1)
      }
    }
  }), _vm._v("開啟\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.showTablewareStrawOption),
      expression: "showTablewareStrawOption",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "showTablewareStrawOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.showTablewareStrawOption, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.showTablewareStrawOption = _vm._n(0)
      }
    }
  }), _vm._v("關閉\n                ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(132), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setTablewareStrawDefaultVal),
      expression: "setTablewareStrawDefaultVal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "setTablewareStrawDefaultVal"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.setTablewareStrawDefaultVal, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.setTablewareStrawDefaultVal = _vm._n(1)
      }
    }
  }), _vm._v("開啟\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setTablewareStrawDefaultVal),
      expression: "setTablewareStrawDefaultVal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "setTablewareStrawDefaultVal"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.setTablewareStrawDefaultVal, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.setTablewareStrawDefaultVal = _vm._n(0)
      }
    }
  }), _vm._v("關閉\n                ")])])])]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), (![9, 11].includes(_vm.storeMethod)) ? _c('div', {
    staticClass: "box-footer text-center"
  }, [((!_vm.info && _vm.storeMethod === 1) || _vm.info) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.goToStoreTable()
      }
    }
  }, [_vm._v("\n        取消\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.storeMethod !== 1) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.goStep(-1)
      }
    }
  }, [_vm._v("\n        上一步\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.storeMethod !== _vm.crStep[_vm.crStep.length - 1]) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.goStep(1)
      }
    }
  }, [_vm._v("\n        下一步\n      ")]) : (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.loading
    },
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n        新增\n      ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? [(_vm.addressChanged) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#addressModal"
    }
  }, [_vm._v("\n          修改\n        ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n          修改\n        ")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.editOption,
      "selectChange": _vm.selectChange,
      "selectOptions": _vm.selectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange,
      "inputOnChange": _vm.inputOnChange
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.leaveOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.addressOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.einOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }, [_c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row ein-row"
  }, [_c('div', {
    staticClass: "col-sm-6 ein-col"
  }, [_c('div', {
    staticClass: "ein-card"
  }, [_c('div', {
    staticClass: "ein-card-title"
  }, [_vm._v("門市基本資訊")]), _vm._v(" "), _c('div', {
    staticClass: "ein-card-item"
  }, [_c('span', {
    staticClass: "ein-card-dot"
  }, [_vm._v("・")]), _vm._v("\n                統一編號\n                "), _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v(_vm._s(_vm.einCheckStoreEin || '無'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 ein-col"
  }, [_c('div', {
    staticClass: "ein-card"
  }, [_c('div', {
    staticClass: "ein-card-title"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('div', {
    staticClass: "ein-card-item"
  }, [_c('span', {
    staticClass: "ein-card-dot"
  }, [_vm._v("・")]), _vm._v("\n                金流帳戶統一編號\n              ")]), _vm._v(" "), _c('ol', {
    staticClass: "ein-card-list"
  }, _vm._l((_vm.einCheckList), function(trade, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                  " + _vm._s(trade.name) + "\n                  "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(trade.ein || '無'))])])
  }), 0)])])]), _vm._v(" "), _c('p', {
    staticClass: "ein-message"
  }, [_vm._v("\n          您設定的統編不一致，將可能影響款項對帳作業，請問是否仍要儲存？\n        ")])])], 2)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("店家資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              店名\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              店名縮寫\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              群組\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              電話1\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("\n          (圖片大小為200x200)\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("\n          (圖片大小為800x460)\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("店家資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              電話1\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("\n          (圖片大小為200x200)\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("\n          (圖片大小為800x460)\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              API服務類型\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              營業狀態\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              距離計算模式\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              條碼類型\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              金額進位\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              優惠券形式\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              自訂設定顯示方式\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              店家是否開立發票\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開放紙本發票\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開放電子載具\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              前端顯示此店家\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              首頁是否搜尋的到店家\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("支援客製餐點貼紙\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("貼紙限制字數\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            單品備註\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開通門市會員卡\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("單筆訂單最高上限(單位:元)\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單版型\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("飲料溫度顯示(冷 熱 無溫度)\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單產品圖示顯示\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單選項展開類型\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單當日停賣樣式\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("菜單永久停賣樣式\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("菜單0元價格顯示")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("菜單編輯權限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("菜單同步權限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                自訂或複製店家的菜單\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                自訂或複製店家的別名/描述/警語\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                自訂或複製店家的圖片庫\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                加入至門市群組\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                選擇要加入的群組名稱\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            綁定POS帳號\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("POS帳號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("POS廠商")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("角色類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("動作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            自訂或複製店家的廣告\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            複製廣告類型\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            選擇店家\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("預訂設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            開始預訂(距今日幾天，0為當日)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            結束預訂(距開始預訂幾天，0為開始預訂日)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            自動拒絕預約單時間(單位:分鐘)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("接單/送單設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          接單狀態\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            暫停接單理由\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            自動拒單時間(單位:分鐘)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          當日訂購時間前下單\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            結束訂購時間後下單\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            距營業時間多久方可訂購(單位:分鐘)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            距打烊時間多久為最後訂購(單位:分鐘)\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("付款方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    前台顯示畫面，如下方粉色備註區塊\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/trade_remark_ex.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("現金付款設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款順序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款方式")]), _vm._v(" "), _c('td', [_vm._v("起始金額")]), _vm._v(" "), _c('td', [_vm._v("結束金額")]), _vm._v(" "), _c('td', [_vm._v("描述")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("製作/取餐時間")]), _vm._v(" "), _c('div', [_vm._v("\n          準備時間需設定 3 分鐘以上，取餐時間間隔需設定 10 的倍數\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐類型")]), _vm._v(" "), _c('td', [_vm._v("準備時間")]), _vm._v(" "), _c('td', [_vm._v("取餐時間間隔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              月份\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              時間類型\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開始\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              開始\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              結束\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              結束\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              取餐類型\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("準備時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("取餐方式/門檻")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各列設定為群組功能，需將取餐類型的每個規則一併設定後才可進行修改。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text text-align-left"
  }, [_vm._v("\n                    ．計算商品金額 (折扣後) ，不含塑膠袋。"), _c('br'), _vm._v("\n                    ．0元為最低消費金額\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在購物車頁面上，消費者可查看，前台顯示畫面，如下方粉色備註區塊\n                    "), _c('img', {
    attrs: {
      "alt": "備註描述圖片",
      "src": "/static/img/delivery_memo_ex.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在訂單確認頁面上，消費者可查看，如預覽圖所示。\n                    "), _c('img', {
    attrs: {
      "alt": "取餐提醒圖片",
      "src": "/static/img/delivery_pickup_memo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("外送門檻排除指定商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("新增排除商品/套餐後，該商品金額將不納入外送門檻金額計算")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("商品、套餐當中存在相同商品，設定互不影響 (例如：若僅排除商品「珍珠奶茶」，未排除套餐「珍珠奶茶+雞排」，套餐仍會被計算於外送門檻費用中。)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("若您設定了多個相同商品名稱但商品料號不同的商品，前台將會合併顯示為一筆項目，以簡化消費者的瀏覽體驗")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("所有排除項目皆需儲存後，才能使用複製功能")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("無資料")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            送餐方式\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              桌號必填\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              桌號編輯\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              桌號顯示\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              訪客下單\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              預設登入方式\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排除取餐類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("指定日期")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("星期")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("每月幾號")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade text-left",
    attrs: {
      "role": "dialog",
      "id": "pickupWarnModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n              預設項目不可關閉，請先調整預設的取餐類型\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("營業時間")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("星期")]), _vm._v(" "), _c('td', [_vm._v("營業時間")]), _vm._v(" "), _c('td', [_vm._v("打烊時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 設定完成後，指定日期將套用此營業時間顯示，期間結束後即恢復預設營業時間。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 若與公休日期重複，會優先顯示指定日期的營業時間。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在前台門市營業時間後方，如下範例："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/specialDay_remark_tooltips.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("公休時間")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("公休時間下單\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("塑膠袋設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                塑膠袋功能\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                    「 塑膠袋功能 」將顯示於購車第一步驟，提供消費者選擇。\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/plastic-select-sample-img.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              塑膠袋單位(幾份商品一個塑膠袋)\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("出單機設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("辨識碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("方式\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("識別碼\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("類型\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選擇出單機\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("出單機列印格式設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("列印格式")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("觸發類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("網址設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 若開啟內用-桌邊掃碼取餐類型，門市可利用網址設定功能，新增桌號並獲取各桌獨立網址，將該網址轉為QRCode後即可運用於提供給顧客做桌邊掃碼點餐。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("計費方式設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選擇計費方式\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("資訊服務費抽成%\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "請勿輸入空格"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("取貨方式\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("抽成生效日\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "系統依據該日期開始計算到資訊服務費抽成報表"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("抽成結束日\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "系統依據該日期停止計算到資訊服務費抽成報表"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("門市獨立產出抽成對帳表")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "適用於門市獨立簽約的類型"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left m-b-15"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#leaveModal"
    }
  }, [_vm._v("\n              前往修改\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("額度計算\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("每月作廢訂單額度（筆）\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("門市每月作廢訂單額度（筆）\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("物流設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          扣款對象\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("配送物流")]), _vm._v(" "), _c('td', [_vm._v("開啟狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("特殊需求")]), _vm._v(" "), _c('div', [_vm._v("請確認POS端是否支援此功能")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n              自選吸管或餐具功能\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                  「 自選吸管或餐具功能 」 將顯示於購車第一步驟，提供消費者選擇。\n                  "), _c('img', {
    attrs: {
      "src": "/static/img/straw-option-sample-img.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("預設吸管或餐具選項\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b80521a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/Temp/StoreFormTemp.vue
// module id = 2440
// module chunks = 1